/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

/**
 * @url https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-7.html#assertion-functions
 */

import { isNotNil } from 'es-toolkit';

import type { NonEmptyArray } from './util-types';

export type Nullish<T> = T | null | undefined;

export function assert(condition: unknown, error: Error | string = new Error()): asserts condition {
  if (!condition) {
    const assertionError = typeof error === 'string' ? new Error(error) : error;

    throw assertionError;
  }
}

export function assertNonEmptyArray<T>(
  arr: T[],
  error: Error | string = new Error('EmptyArray')
): asserts arr is NonEmptyArray<T> {
  assert(arr.length > 0, error);
}

export function isEnumValue(enumObj: Record<string, string>, val: string | undefined | null) {
  return isNotNil(val) && Object.values(enumObj).includes(val);
}
